module.exports = __webpack_public_path__ + "static/media/menu-banesco-logo-bg.b8ec7a1f.svg";